import arrow from "../../../../assets/icons/arrow.svg";
import BarekamButton, { HeaderButtons } from "../../../components/button";
import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useAppSelector } from "../../../../redux/store";
import BarekamText from "../../../components/text";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageModel } from "../../../../redux/reducers/static-data.reducers";
import {
  BarekamIcon,
  IconVariants,
} from "../../../components/icon/barekam-icon";
import { supportedLanguages } from "../../../../constants";
import { GapContainer } from "../../../components/card/styled";

const LanguageButton = ({
  isDesktop,
  newHeader = false,
}: {
  isDesktop: boolean;
  newHeader?: boolean;
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { matchesPhone } = useAppSelector((state) => state.deviceReducer);

  const { languages } = useAppSelector((state) => state.staticDataReducer);

  const { languageId } = useAppSelector((state) => state.messagesReducer);
  const selectedLanguage = languages.find(
    (message) => message.languageId === languageId,
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const userMenuOpened = Boolean(anchorEl);

  const openLanguageMenu = (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    event: MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleButtonClick = (selectedLanguage: LanguageModel) => {
    resetAnchorEl();

    const currentLanguage = languages.find(
      (language) => language.languageId === languageId,
    );

    if (currentLanguage) {
      const newLocation = location.pathname.replace(
        `/${currentLanguage.abbreviation}/`,
        `/${selectedLanguage.abbreviation}/`,
      );
      navigate(newLocation + location.search + location.hash);
    }
  };

  const resetAnchorEl = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <BarekamButton
        type={HeaderButtons.SIMPLE}
        onClick={(event) => openLanguageMenu(event)}
      >
        <BarekamIcon
          variant={IconVariants.flag}
          country={supportedLanguages[languageId - 1]}
        />

        {isDesktop && !newHeader ? (
          <BarekamText variant={"header"} bold>
            <Message
              messageKey={selectedLanguage?.name}
              sectionId={MessageSections.MAIN}
            />
          </BarekamText>
        ) : (
          ""
        )}

        {matchesPhone ? (
          ""
        ) : (
          <img
            src={arrow}
            alt={"arrow"}
            style={{ height: isDesktop ? "unset" : "0.4rem" }}
          />
        )}
      </BarekamButton>

      <Menu
        open={userMenuOpened}
        anchorEl={anchorEl}
        onClose={() => resetAnchorEl()}
      >
        {languages?.map((language) => (
          <MenuItem
            key={language.languageId}
            onClick={() =>
              language.languageId !== languageId && handleButtonClick(language)
            }
          >
            <GapContainer style={{ gap: "1rem" }}>
              <BarekamIcon
                variant={IconVariants.flag}
                country={supportedLanguages[language.languageId - 1]}
              />

              <BarekamText
                variant={"m"}
                opaque={language.languageId === languageId}
              >
                <Message
                  messageKey={language.name}
                  sectionId={MessageSections.MAIN}
                />
              </BarekamText>
            </GapContainer>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageButton;
